class ProductCardList extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['item']
  }

  connectedCallback () {
    super.connectedCallback()

    this.market = `${window.Shopify.currency.active}_${window.Shopify.country}`

    this.Id = this.dataset.id
    this.collectionTitle = this.dataset.collectionTitle
    this.section = this.dataset.section || 'product-card'
    this.limit = this.dataset.limit || 8

    this.fetchProductRecommendations()
  }

  async fetchProductRecommendations () {
    const apiKey = window.theme.collection.klevuAPIKey
    const endpoint = window.theme.collection.klevuAPIURL
    const url = `https://${endpoint}/cs/v2/search`
    const body = {
      recordQueries: [
        {
          id: `productCardList-${this.Id}`,
          typeOfRequest: 'CATNAV',
          settings: {
            priceFieldSuffix: this.market,
            limit: this.limit,
            sort: 'RELEVANCE',
            query: {
              categoryPath: this.collectionTitle,
            },
            fields: ['url'],
            searchPrefs: ['showOutOfStockProducts'],
          },
        },
      ],
      context: {
        apiKeys: [apiKey],
      },
    }

    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    })

    const data = await response.json()
    this.products = data.queryResults?.[0]?.records || []

    this.observeCards()
  }

  observeCards () {
    const items = this.els?.item?.elements || []

    this._observer = new IntersectionObserver(
      entries => {
        entries.forEach(async entry => {
          if (entry.isIntersecting) {
            const item = entry.target
            const index = items.indexOf(item)
            const product = this.products[index]

            if (item.dataset.rendered === 'true') return

            if (product) {
              item.dataset.rendered = 'true'

              switch (this.section) {
                case 'product-card':
                  item.innerHTML = await this.renderDefaultProductCard(product)
                  break
                case 'product-card-brand':
                  item.innerHTML = await this.renderMakerProductCard(product)
                  break
                default:
                  item.innerHTML = await this.renderDefaultProductCard(product)
              }
            } else {
              item.remove()
            }

            this._observer.unobserve(item)
          }
        })
      },
      {
        rootMargin: '200px',
        threshold: 0.01,
      },
    )

    items.forEach(item => {
      this._observer.observe(item)
    })
  }

  async renderDefaultProductCard (product) {
    const productUrl = product.url.replace(
      '/product',
      `${Shopify.routes.root}product`,
    )

    try {
      const html = await window.BAO.sectionRenderer.fetchSingle(
        'product-card',
        productUrl,
      )

      return html
    } catch (e) {
      console.error('Error fetching section:', e)

      return ''
    }
  }

  async renderMakerProductCard (product) {
    const productUrl = product.url.replace(
      '/product',
      `${Shopify.routes.root}product`,
    )

    try {
      const html = await window.BAO.sectionRenderer.fetchSingle(
        'product-card-brand',
        productUrl,
      )

      const doc = new DOMParser().parseFromString(html, 'text/html')
      const linkEl = doc.querySelector('a')
      const linkTitleEl = doc.querySelector('a span')

      if (linkTitleEl && this.dataset.collectionTitle) {
        linkTitleEl.innerHTML = this.dataset.collectionTitle
      }
      if (linkEl && this.dataset.collectionHandle) {
        linkEl.href = `${Shopify.routes.root}collections/${this.dataset.collectionHandle}`
      }

      return doc.body.innerHTML
    } catch (e) {
      console.error('Error fetching section:', e)

      return ''
    }
  }
}

if (!customElements.get('product-card-list')) {
  customElements.define('product-card-list', ProductCardList)
}
